/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import useStyles from 'isomorphic-style-loader/useStyles';
import React from 'react';
import PropTypes from 'prop-types';
import s from './NotFound.css';
import Layout from '../../common/components/Layout/Layout';
import Button from '../../common/components/Button/Button';
import NotfoundWebp from '../../assets/images/404.webp';
import NotfoundPng from '../../assets/images/404.png';

export default function NotFound({ isMobile }) {
  useStyles(s);
  return (
    <Layout isMobile={isMobile}>
      <div className={s.container}>
        <div>
          <picture>
            <source srcSet={NotfoundWebp} type="image/webp" />
            <source srcSet={NotfoundPng} type="image/png" />
            <img src={NotfoundPng} alt="bannerImage" width="100%" />
          </picture>
        </div>
        <div>
          <h3 className={s.code}>404</h3>
          <h1 className={s.title}>متأسفانه صفحه مورد نظر یافت نشد</h1>
          <a href="https://tapsi.ir">
            <Button>بازگشت به صفحه اصلی</Button>
          </a>
        </div>
      </div>
    </Layout>
  );
}

NotFound.propTypes = {
  isMobile: PropTypes.bool.isRequired,
};
